export default "__VITE_ASSET__96e6cf1d__"